import { request } from '@/utils';
// 公示中心相关接口
export interface NoticeItem {
  noticeId: number;
  noticeType: string;
  noticeSubject: string;
  companyName: string;
  createDate: number;
  startDate: number;
  endDate: number;
}

export interface NoticeListResponse {
  total: number;
  list: NoticeItem[];
}

export interface NoticeListParams {
  page?: number;
  pageSize?: number;
  orderDirection?: string;
  noticeType?: string;
  subject?: string;
}

export async function fetchNoticeList({ page = 1, pageSize = 10, orderDirection = 'DESC', noticeType, subject, groupId, memberId }: NoticeListParams) {
  const params: any = {
    pageSize,
    pageIndex: page,
    orderDirection,
  };
  
  // 如果传入了noticeType参数，则添加到请求参数中
  if (noticeType) {
    params.noticeType = noticeType;
  }
  
  // 如果传入了subject参数，则添加到请求参数中进行标题搜索
  if (subject) {
    params.subject = subject;
  }

  if (groupId) {
    params.groupId = groupId;
  }

  if (memberId) {
    params.memberId = memberId;
  }

  const res: any = await request.get('/bcpcrm/rest/api/notice', {
    params
  });
  
  console.log('API原始响应:', res);
  
  // 这里的 res 已经是 data.data，直接返回
  return {
    total: res.total || 0,
    list: res.list || [],
  };
}

export async function getNoticeDetail(noticeId: number | string) {
  const url = `/bcpcrm/rest/api/notice/${noticeId}`;
  const res = await request.get(url);
  return res;
} 